export default () => ({
	banner: null,
	modal: {
		show: false,
		component: null,
		events: null
	}
})
